import { atom } from "recoil";

export const localDataState = atom({
    key: 'localDataState',
    default: false,
});

export const apiPciState = atom({
    key: 'apiPciState',
    default: '',
});

export const banUriState = atom({
    key: 'banUriState',
    default: '',
});

export const apiCollectionState = atom({
    key: 'apiCollectionState',
    default: '',
});

export const userDataState = atom({
    key: 'userDataState',
    default: null,
});

export const repFileState = atom({
    key: 'repFileState',
    default: null,
});

export const idDataEntityState = atom({
    key: 'idDataEntityState',
    default: null,
});

export const selectedNameCollectionState = atom({
    key: 'selectedNameCollectionState',
    default: null,
});

export const activeformNewEntiteState = atom({
    key: 'activeformNewEntiteState',
    default: false,
});

export const activeformEditEntiteState = atom({
    key: 'activeformEditEntiteState',
    default: false,
});

export const typeformEditEntiteState = atom({
    key: 'typeformEditEntiteState',
    default: '',
});

export const collectionsState = atom({
    key: 'collectionsState', 
    default: [],             
});

export const collectionsCurState = atom({
    key: 'collectionsCurState', 
    default: {},
});

export const collectionsShareState = atom({
    key: 'collectionsShareState', 
    default: [],             
});

export const collectionsModeleState = atom({
    key: 'collectionsModeleState', 
    default: [],             
});

export const openCollectionStates = atom({
    key: 'openCollectionStates', 
    default: {},           
});

export const openCollectionShareStates = atom({
    key: 'openCollectionShareStates', 
    default: {},           
});

export const toastState = atom({
    key: 'toastState',
    default: null,
});

export const loadingState = atom({
    key: 'loadingState',
    default: null,
});

export const sortConfigCollectionAtom = atom({
    key: 'sortConfigCollectionAtom', 
    default: null,         
});

export const sortConfigShareAtom = atom({
    key: 'sortConfigShareAtom', 
    default: null,         
});

export const sortConfigModeleAtom = atom({
    key: 'sortConfigModeleAtom', 
    default: null,         
});

export const sortConfigEntityAtom = atom({
    key: 'sortConfigEntityAtom', 
    default: null,         
});

export const sortConfigEntityFileAtom = atom({
    key: 'sortConfigEntityFileAtom', 
    default: null,         
});

export const searchQueryCollectionAtom = atom({
    key: 'searchQueryCollectionAtom', 
    default: '', 
});

export const searchQueryShareAtom = atom({
    key: 'searchQueryShareAtom', 
    default: '', 
});

export const searchQueryModeleAtom = atom({
    key: 'searchQueryModeleAtom', 
    default: '', 
});

export const searchQueryEntityAtom = atom({
    key: 'searchQueryEntityAtom', 
    default: '', 
});

export const searchQueryEntityFileAtom = atom({
    key: 'searchQueryEntityFileAtom', 
    default: '', 
});

export const currentPageCollectionAtom = atom({
    key: 'currentPageCollectionAtom', 
    default: 1, 
});

export const currentPageShareAtom = atom({
    key: 'currentPageShareAtom', 
    default: 1, 
});

export const currentPageModeleAtom = atom({
    key: 'currentPageModeleAtom', 
    default: 1, 
});

export const currentPageEntityAtom = atom({
    key: 'currentPageEntityAtom', 
    default: 1, 
});

export const currentPageEntityFileAtom = atom({
    key: 'currentPageEntityFileAtom', 
    default: 1, 
});

export const markerFormState = atom({
    key: "markerFormState",
    default: {
      nomEntite: "",
      observation: "",
      latitude: "",
      longitude: "",
      markerColor: "#252525",
      iconColor: "#ffffff",
      markerShape: "circle",
      iconClass: "fa fa-circle"
    }
});

export const markerFormEditState = atom({
    key: "markerFormEditState",
    default: {
        latitude: null,
        longitude: null,
        nomEntite: "",
        observation: "",
        markerColor: "#000000",
        iconColor: "#FFFFFF",
        markerShape: "",
        iconClass: "",
        textColor: "#252525",
        textSize: 12,
        lineColor: "#92bbf4",
        lineOpacity: 0.5,
        lineEpaisseur: 4,
        polycontourColor: "#92bbf4",
        polycontourOpacity: 0.5,
        polycontourEpaisseur: 4,
        polyColor: "#92bbf4",
        polyOpacity: 0.2,
        radius: 0
    }
});

export const modeleLayerCurState = atom({
    key: 'modeleLayerCurState',
    default: null,
});


export const idLayerEditState = atom({
    key: 'idLayerEditState',
    default: null,
});

export const distanceTotalState = atom({
    key: 'distanceTotalState',
    default: '',
});

export const typeCollectionState = atom({
    key: 'typeCollectionState',
    default: 'collection',
});

export const reloadCollectionState = atom({
    key:'reloadCollectionState',
    default:false
});

export const reloadEntiteState = atom({
    key:'reloadEntiteState',
    default:false
});

export const boolModifState = atom({
    key:'boolModifState',
    default:false
});

export const collectionTabState = atom({
    key: 'collectionTabState', 
    default: 'collections', 
});


export const addEntiteFileState = atom({
    key:'addEntiteFileState',
    default: [],       
});